import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject, Subscription} from 'rxjs';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';
import {InsolesSummaryModel} from '../../model/insolesSummary.model';
import {InsolesSummaryFindAllService} from '../../../impl/service/insolesSummaryFindAll.service';

@Component({
  selector: 'app-insoles-select-filter',
  templateUrl: './insoles-select-filter.component.html',
})
export class InsolesSelectFilterComponent implements OnInit, OnDestroy {

  @Input() service: InsolesSummaryFindAllService;
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() noValueLabel: 'Aucun semelles';
  @Output() selectionChangedEvent = new EventEmitter<InsolesSummaryModel>();

  subscriptions: Subscription[] = [];
  loading = false;

  elements: BehaviorSubject<SelectFilterElement<number, InsolesSummaryModel>[]> =
      new BehaviorSubject<SelectFilterElement<number, InsolesSummaryModel>[]>([]);

  ngOnInit() {
    this.subscriptions.push(this.service.entities$.subscribe(entities => {
      this.elements.next(entities ? entities.map(value => new SelectFilterElement(value.id, value.id, value)) : []);
    }));
    this.subscriptions.push(this.service.loading$.subscribe(loading => {
      this.loading = loading;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(value => value.unsubscribe());
  }

  filter = (criteria: string, entity: InsolesSummaryModel) => {
    return (entity.id + ' ' + entity.color.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

}
